// extracted by mini-css-extract-plugin
module.exports = {"image-position":"fallback-m__image-position__37ZBk","image":"fallback-m__image__2GEw7 fallback-m__image-position__37ZBk","fallback-svg":"fallback-m__fallback-svg__y9LBW"};